<template>
  <v-dialog :persistent="persistent" v-model="dialog" max-width="480px">
    <v-card>
      <v-card-title class="mx-3">
        {{ title ? title : $t("$vuetify.alert") }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false; $emit('cancel')">
              fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-4 py-8 text-center subtitle-1">
        {{ message }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="secondary"
          outlined
          @click="
            $emit('cancel');
            dialog = false;
          "
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn
          v-if="useConfirm"
          color="accent"
          depressed
          @click="
            $emit('confirm');
            dialog = false;
          "
        >
          {{ $t("$vuetify.confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogAlert",

  props: {
    value: Boolean,
    title: String,
    message: String,
    useConfirm: Boolean,
    persistent: Boolean,
  },

  data: () => ({
    dialog: false,
  }),

  watch: {
    value: {
      immediate: true,
      handler() {
        this.dialog = this.value;
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) this.$emit("close");
      },
    },
  },
};
</script>
